<div #tooltipelem class="tooltip-wrapper">
  <div class="tooltip-header">
    <div class="person-box">
      <img class="header-icon" src="assets/img/person_icon_2.svg" alt="">
      <div class="person-info">
        <span>ID: {{shiftInfo.personId}}</span>
        <span style="text-transform: uppercase;">{{'Shift' | translate}}: {{shiftInfo.shiftId}}</span>
      </div>
      <div class="header-icon">
        <qm-click-to-call [personId]="shiftInfo.personId"></qm-click-to-call>
      </div>
    </div>
    <div class="shift-length-info">
      <div class="shift-length-box">
        <div class="shift-length-value">
          {{shiftInfo.shiftLength}}
        </div>
        <div class="shift-length-heading">
          {{'Shift length' | translate}}
        </div>
      </div>
      <div class="shift-time-box">
        <div>
          <span class="shift-time-heading">
            {{'Starts:' | translate}}
          </span>
          <span class="shift-time-value">
            {{shiftInfo.startTime}}
          </span>
        </div>
        <div>
          <span class="shift-time-heading">
            {{'Ends:' | translate}}
          </span>
          <span class="shift-time-value">
            {{shiftInfo.endTime}}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="shift-tasks-row">
    <div class="shift-task-info" *ngFor="let taskInfo of shiftTaskInfo; let i=index">
      <div class="shift-task-info-column" *ngIf="i == 0">
        <div class="station">{{taskInfo.prevStation}}</div>
        <div>{{taskInfo.taskStartTime}}</div>
        <img class="arrow-icon" src="assets/img/vr_departure.svg" alt="">
      </div>
      <div class="shift-task-info-column">
        <div class="task-role">
          <div 
            (click)="openTrainInfo($event, taskInfo)"
            [ngClass]="{
              'task-label': true,
              'green-background': taskInfo.taskType == 'train' && !taskInfo.shiftConflict,
              'dark-blue-background': taskInfo.taskType == 'transfer' && !taskInfo.shiftConflict,
              'red-background': taskInfo.shiftConflict}">
            {{taskInfo.taskLabel ? (taskInfo.taskLabel | translate) : '-'}}
          </div>
          <div>{{taskInfo.role}}</div>
        </div>
      </div>
      <div class="shift-task-info-column" *ngIf="i < shiftTaskInfo.length - 1">
        <div class="station">{{taskInfo.taskChange.station}}</div>
        <div style="display: flex; text-align: start;">
          <div style="flex-grow: 1;">{{taskInfo.taskChange.startTime}}</div>
          <div>{{taskInfo.taskChange.endTime}}</div>
        </div>
        <img class="arrow-icon" src="assets/img/vr_arriving.svg" alt="">
        <img class="dots" src="assets/img/vr_dots.svg" alt="">
        <img class="arrow-icon" src="assets/img/vr_departure.svg" alt="">
      </div>
      <div class="shift-task-info-column" *ngIf="i == shiftTaskInfo.length - 1">
        <div class="station">{{taskInfo.nextStation}}</div>
        <div>{{taskInfo.taskEndTime}}</div>
        <img class="arrow-icon" src="assets/img/vr_arriving.svg" alt="">
      </div>
    </div>
  </div>
</div>
